import { createPrintJob, type PreviewOptions } from "../../src/index";

// This example demonstrates template-style absolute positioning so the demo also
// covers semi-fixed forms rather than only flowing report layouts.
export function createFormTemplateExample() {
  const job = createPrintJob({
    title: "Form Template",
    pageSize: "A4",
    orientation: "portrait",
    margins: { top: "12mm", right: "12mm", bottom: "12mm", left: "12mm" },
    fontFamily: '"Segoe UI", "PingFang SC", sans-serif'
  });

  job
    .addHtml(`<div style="height:250mm;position:relative;border:1px solid #cbd5e1;border-radius:20px;background:#fff;"></div>`, {
      keepTogether: true
    })
    .addText("Inspection Form Template", {
      box: { x: "10mm", y: "12mm", width: "90mm" },
      style: { fontSize: "24px", fontWeight: 700, letterSpacing: "0.03em" }
    })
    .addText("Document No.", {
      box: { x: "10mm", y: "30mm", width: "30mm" },
      style: { fontSize: "12px", fontWeight: 600 }
    })
    .addText("IF-20260610-01", {
      box: { x: "44mm", y: "30mm", width: "50mm" },
      style: { fontSize: "12px" }
    })
    .addText("Inspector", {
      box: { x: "10mm", y: "44mm", width: "30mm" },
      style: { fontSize: "12px", fontWeight: 600 }
    })
    .addText("Warehouse QA Team", {
      box: { x: "44mm", y: "44mm", width: "60mm" },
      style: { fontSize: "12px" }
    })
    .addText("Checklist", {
      box: { x: "10mm", y: "64mm", width: "30mm" },
      style: { fontSize: "12px", fontWeight: 600 }
    })
    .addHtml(
      `<div style="font-size:12px;line-height:1.7;">
        □ Seal intact<br />
        □ Temperature logged<br />
        □ Carton count confirmed<br />
        □ Supervisor sign-off complete
      </div>`,
      {
        box: { x: "44mm", y: "62mm", width: "80mm", height: "46mm" }
      }
    )
    .addText("Remarks", {
      box: { x: "10mm", y: "120mm", width: "30mm" },
      style: { fontSize: "12px", fontWeight: 600 }
    })
    .addHtml(
      `<div style="border:1px solid #cbd5e1;border-radius:12px;height:28mm;padding:8px;font-size:12px;color:#334155;">
        Record any deviations, damaged seals, or rework notes here.
      </div>`,
      {
        box: { x: "44mm", y: "116mm", width: "110mm", height: "32mm" }
      }
    )
    .addPageBreak()
    .addHtml(`<div style="height:250mm;position:relative;border:1px solid #cbd5e1;border-radius:20px;background:#fff;"></div>`, {
      keepTogether: true
    })
    .addText("Approval Section", {
      box: { x: "10mm", y: "12mm", width: "44mm" },
      style: { fontSize: "14px", fontWeight: 700 }
    })
    .addText("Supervisor", {
      box: { x: "10mm", y: "34mm", width: "30mm" },
      style: { fontSize: "12px", fontWeight: 600 }
    })
    .addText("Cold Chain Lead", {
      box: { x: "44mm", y: "34mm", width: "54mm" },
      style: { fontSize: "12px" }
    })
    .addText("Decision", {
      box: { x: "10mm", y: "50mm", width: "30mm" },
      style: { fontSize: "12px", fontWeight: 600 }
    })
    .addHtml(
      `<div style="font-size:12px;line-height:1.8;">
        □ Release shipment<br />
        □ Hold for recheck<br />
        □ Request repacking
      </div>`,
      {
        box: { x: "44mm", y: "48mm", width: "72mm", height: "32mm" }
      }
    )
    .addText("Signature Block", {
      box: { x: "10mm", y: "182mm", width: "40mm" },
      style: { fontSize: "12px", fontWeight: 600 }
    })
    .addHtml(
      `<div style="height:30mm;border:1px dashed #94a3b8;border-radius:12px;padding:8px;font-size:12px;color:#64748b;display:flex;align-items:flex-end;">
        Sign here after final approval.
      </div>`,
      {
        box: { x: "44mm", y: "176mm", width: "96mm", height: "34mm" }
      }
    );

  const previewOptions: Omit<PreviewOptions, "container"> = {
    mode: "paged",
    paginationStrategy: "manual",
    showPageNumbers: true
  };

  return {
    id: "form-template",
    title: "Form Template",
    description: "A two-page semi-fixed inspection form that demonstrates page-relative positioned template blocks and second-page coordinate consistency.",
    job,
    defaultPreviewOptions: previewOptions
  };
}
